import axios, { AxiosResponse } from "axios";
import { hub_non_vip_seller_validation_url } from "../constants/urls";

import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { Attachement } from "@/interfaces/Attachement";
import { ServerResponse } from "@/interfaces/Server";

export async function validerRetourVendeurParHUB(
  returnNumber: string,
  attachement: Attachement
): Promise<AxiosResponse<ServerResponse>> {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse> = await axios({
      url: hub_non_vip_seller_validation_url,
      headers: defaultHeadersWithToken(accessToken),
      data: {
        numTournee: returnNumber,
        attachement: attachement.attachement,
        attachementName: attachement.attachementName,
      },
      method: "POST",
    });
    return response;
  } catch (error: any) {
    return error.response;
  }
}
